const SellerProfile = () => {
    return <div>Seller Profile</div>
}

export { SellerProfile }
